module.exports = "/assets/data/d83642ab6032a63feaa8ddd75df2e6e2-GU12.data.json";